import { IMapZoneInfoDTO, IUserLocationRecordDTO, MailAddressModel } from "api/swagger/ApiClient";
import { QueryMemory } from "support/shared_models/query-memory";
import { Country, Site } from "./business-keywords";
import { UserContact } from "./business-types";

export interface UsersLocationsQueryFilter {
  text: string | null;
  user: UserContact | null;
  country: Country | null;
  mapZone: IMapZoneInfoDTO | null;
  insideMapZone: boolean;
  site: Site | null;
  selectedLocation: L.LatLng | null;
  distanceFromSiteInMeters: number | null;
  locationCurrentnessStatus: number | null;
  canSearch: boolean;
}

export interface UsersLocationsMapFilter {
  isSynchronized: boolean;
  areSitesDisplayed: boolean;
}

export interface UserLocation extends IUserLocationRecordDTO {
  isSelected: boolean;
  isHighlighted: boolean;
  isDetail: boolean;
}

export interface UsersEmail {
  from: MailAddressModel | null,
  subject: string | null,
  message: string | null
}

export class UsersLocationsQueryMemory extends QueryMemory<UsersLocationsQueryFilter> {
}
